/* global Uint8Array */
// TODO take these exceptions away once we have enough test coverage to catch regressions while fixing these linting errors
/* eslint complexity: "off" , max-depth: "off", max-statements: "off", max-len: "off" */
import $ from 'jquery';
import { inflateRaw } from 'pako';

function getAppLink(window, orgUrl) {
  var pattern = /^(https?:\/\/)?([A-Za-z0-9-]{1,63})(\.\S+)/;
  var matches = orgUrl.match(pattern);

  if (matches && matches.length === 4) {
    var url = [];
    url.push(matches[1]);

    var request = getQueryVariable(window.location.search, 'SAMLRequest');
    var relayState = getQueryVariable(window.location.search, 'RelayState');
    var issuer = parseSamlRequest(request);
    if ((issuer && issuer.toLowerCase().indexOf('corpwebsite') > -1)
      && (matches[3] === '.oktapreview.com')) {
      // if user try to access org in preview or trex, redirect to end user app page instead of sso into corp website
      // as we currently dont support sso into corp website from preview orgs
      return matches[1] + matches[2] + matches[3] + '/app/UserHome';
    } else if (issuer) {
      var acsUrl = getSamlAcsUrl(issuer);

      if (acsUrl.toLowerCase().indexOf('/admin/') === 0) {
        url.push(matches[2] + '-admin');
      } else {
        url.push(matches[2]);
      }

      url.push(matches[3]);
      url.push(acsUrl);
      
      // CIAM workaround
      // SFDC throws error when SAMLRequest sent
      // do not append SAMLRequest or relay state when servicecloud or status issuer
      // temporary unblock
      if (acsUrl && acsUrl.indexOf('servicecloud') > -1 || acsUrl.indexOf('status') > -1) {
        if (relayState) {
          url.push('?');
          url.push('RelayState=');
          url.push(encodeURIComponent(relayState));
        }
      } else {
        url.push('?');
        url.push('SAMLRequest=');
        url.push(encodeURIComponent(request));
        if (relayState) {
          url.push('&');
          url.push('RelayState=');
          url.push(encodeURIComponent(relayState));
        }
      }
      return url.join('');
    } else if (window.location.pathname === '/oauth2/v1/authorize') {
      return `${orgUrl}${window.location.pathname}${window.location.search}`;
    } else {
      if (matches[2] != 'my') {
        return matches[1] + matches[2] + matches[3] + '/app/UserHome';
      } else {
        return matches[1] + matches[2] + matches[3] + '/user/sso/corpwebsite';
      }
    }
  }
}

function getSamlAcsUrl(issuer) {
  if (issuer && issuer.toLowerCase().indexOf('influitive') > -1) {
    return '/admin/crossorg/sso/ozone';
  } else if (issuer && issuer.toLowerCase().indexOf('torii') > -1) {
    return '/user/sso/torii';
  } else if (issuer && issuer.toLowerCase().indexOf('cornerstone') > -1) {
    return '/user/sso/cornerstone';
  } else if (issuer && issuer.toLowerCase().indexOf('quickmobile') > -1) {
    return '/user/sso/quickmobile';
  } else if (issuer && issuer.toLowerCase().indexOf('cvent') > -1) {
    return '/user/sso/cvent';
  } else if (issuer && issuer.toLowerCase().indexOf('servicecloud') > -1) {
    return '/user/sso/servicecloud';
  } else if (issuer && issuer.toLowerCase().indexOf('status') > -1) {
    return '/admin/crossorg/sso/status';
  } else {
    return '/user/sso/corpwebsite';
  }
}

// Use jquery to parse SAML Request XML for IE 9,10,11 compatibility (tested in 10 and 11)
function parseSamlRequest(req) {
  try {
    const decodedReq = zlibDecompress(req);
    const noNamespace = removeXMLNamespaces(decodedReq);
    const xmlDoc = $.parseXML(noNamespace, 'application/xml');
    const $xml = $(xmlDoc);
    const issuer = $.trim($xml.find('Issuer').first().text());
    return issuer;
  } catch (err) {
    return '';
  }
}
// Remove namespaces in SAML before parsing XML
function removeXMLNamespaces(decodedXML) {
  const regex = new RegExp(/(<\/?)[a-z_][a-z0-9-_.]*:([a-z_][a-z0-9-_.]*)(>?)/gi);
  const noNamespace = decodedXML.replace(regex, '$1$2$3');
  return noNamespace;
}

function zlibDecompress(base64Content) {
  // Convert binary string to character-number array
  var charData = atob(base64Content).split('').map(function (x) { return x.charCodeAt(0); });
  var decodedData = inflateRaw(new Uint8Array(charData), { to: 'string' });
  return decodedData;
}

function getQueryVariable(path, variable) {
  if (path && variable) {
    var query = path.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
  }
}

module.exports = {
  getAppLink,
  getSamlAcsUrl,
  getQueryVariable,
  parseSamlRequest,
  removeXMLNamespaces
};


// WEBPACK FOOTER //
// ./lib/saml-redirect-util.js